"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerExampleWrapper = exports.DateMarkerLegendUl = exports.DateMarkerLegendLi = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var DateMarkerLegendUl = (0, _context.styledWithTheme)('ul')(function (_ref) {
  var selectors = _ref.theme.selectors,
      layout = _ref.layout;
  var flexDirection = layout === _interfaces.DateMarkerLegendLayout.Horizontal ? 'row' : 'column';
  return {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: flexDirection,
    flexWrap: 'wrap',
    gap: "".concat((0, _utils.px)(selectors.space(_constants.VERTICAL_SPACING)), " ").concat((0, _utils.px)(selectors.space(_constants.HORIZONTAL_SPACING)))
  };
});
exports.DateMarkerLegendUl = DateMarkerLegendUl;
var DateMarkerLegendLi = (0, _context.styledWithTheme)('li')();
exports.DateMarkerLegendLi = DateMarkerLegendLi;
var MarkerExampleWrapper = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e684mnz0"
})(process.env.NODE_ENV === "production" ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2RhdGUtcGlja2VyL2RhdGUtbWFya2VyLWxlZ2VuZC9oZWxwZXJDb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCb0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvZGF0ZS1waWNrZXIvZGF0ZS1tYXJrZXItbGVnZW5kL2hlbHBlckNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHN0eWxlZFdpdGhUaGVtZSB9IGZyb20gJy4uLy4uL2NvbnRleHQnO1xuaW1wb3J0IHsgcHggfSBmcm9tICcuLi8uLi91dGlscyc7XG5cbmltcG9ydCB7IEhPUklaT05UQUxfU1BBQ0lORywgVkVSVElDQUxfU1BBQ0lORyB9IGZyb20gJy4vY29uc3RhbnRzJztcbmltcG9ydCB7IERhdGVNYXJrZXJMZWdlbmRMYXlvdXQgfSBmcm9tICcuL2ludGVyZmFjZXMnO1xuXG5leHBvcnQgY29uc3QgRGF0ZU1hcmtlckxlZ2VuZFVsID0gc3R5bGVkV2l0aFRoZW1lKCd1bCcpPHtcbiAgbGF5b3V0OiBEYXRlTWFya2VyTGVnZW5kTGF5b3V0O1xufT4oKHsgdGhlbWU6IHsgc2VsZWN0b3JzIH0sIGxheW91dCB9KSA9PiB7XG4gIGNvbnN0IGZsZXhEaXJlY3Rpb24gPVxuICAgIGxheW91dCA9PT0gRGF0ZU1hcmtlckxlZ2VuZExheW91dC5Ib3Jpem9udGFsID8gJ3JvdycgOiAnY29sdW1uJztcbiAgcmV0dXJuIHtcbiAgICBsaXN0U3R5bGVUeXBlOiAnbm9uZScsXG4gICAgbWFyZ2luOiAwLFxuICAgIHBhZGRpbmc6IDAsXG4gICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgIGZsZXhEaXJlY3Rpb24sXG4gICAgZmxleFdyYXA6ICd3cmFwJyxcbiAgICBnYXA6IGAke3B4KHNlbGVjdG9ycy5zcGFjZShWRVJUSUNBTF9TUEFDSU5HKSl9ICR7cHgoXG4gICAgICBzZWxlY3RvcnMuc3BhY2UoSE9SSVpPTlRBTF9TUEFDSU5HKVxuICAgICl9YFxuICB9O1xufSk7XG5cbmV4cG9ydCBjb25zdCBEYXRlTWFya2VyTGVnZW5kTGkgPSBzdHlsZWRXaXRoVGhlbWUoJ2xpJykoKTtcblxuZXhwb3J0IGNvbnN0IE1hcmtlckV4YW1wbGVXcmFwcGVyID0gc3R5bGVkKCdkaXYnKSh7XG4gIHBvc2l0aW9uOiAncmVsYXRpdmUnXG59KTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.MarkerExampleWrapper = MarkerExampleWrapper;